module.exports = __webpack_public_path__ + "static/media/ab67616d0000b2736bdcdf82ecce36bff808a40c-394x394.c743a0f4.jpg";